var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.weatherName.cod != 404 && _vm.weatherName.cod != undefined)?_c('div',{staticClass:"container",style:(("background-image: url(" + _vm.bgImage + "); height: " + _vm.viewportHeight + "px"))}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }